import React,{ useEffect, useRef } from "react";
import { useNavigate,Link } from "react-router-dom";
import { useState } from "react";
import { host,getAllInvoice } from "../../proxyUrl";

import axios from "axios";
// import $ from "jquery";
// import DataTables from "datatables.net";

// const DataTable = DataTables(Window, $);


const pageSize = 10; // Number of items per page
// const getLink = ()=>{
//   alert('ss');
//   // ${editRoute}/
//   // return('sss')
// }


export default function InvoiceTable(props) {
  
  // const navigate = useNavigate();
  const {  setInvoiceData, tableData, editRoute,generateInvoice, deleteRoute } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');

  // Calculate total number of pages
  const totalPages = Math.ceil(tableData.length / pageSize);

  // Calculate the index range of the current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  // Get the current page's data
  const currentData = tableData.slice(startIndex, endIndex);
  // const getLink = ()=>{
  //   alert('ss');
  //   // ${editRoute}/
  //   // return('sss')
  // }

  // const tableRef = useRef();
  useEffect(()=>{
    if(search.length>2 ||search.length<1 ){
      axios
        .get(getAllInvoice+"?search="+search,{
          withCredentials: true,
        })
        .then((res) => {
          return res;
        })
        .then((invoicedata) => {
          const invoiceData = invoicedata.data;
          setInvoiceData(invoiceData);
        })
    }
    },[search]);
      
  // useEffect(() => {
  //   console.log(tableData);
    // When component loads, fill table with data
  //   new DataTable(tableRef.current, {
  //     data: tableData,
  //     columns: [
  //       { title: "id",name:'id' ,data:'id'},
  //       { title: "companyName",name:'companyName' ,data:'companyName'},
  //       { title: "email",name:'email' ,data:'email'},
  //       { title: "phoneNo",name:'phoneNo',data:'phoneNo' },
  //       // { title: "Action",name:'Action',data: (d) => {return `<a href="#" onclick="(()=>{navigate('${generateInvoice}/${d.id}');})()">aaaa</a>`} }
  //       {
  //         title: "sss",
  //         Header: "Description",
  //         accessor: "Description",
  //         onClick: () => { alert('click!'); },
  //         cell: (props) => {  return `<h1>sd dd d</h1>`;
  //         }
  //       }
  //     ],
  //   });
  // }, []);


  // Handle previous page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Handle next page
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <>
      <section className="container mx-auto px-4 ">
        <div className=" flex flex-col">
          <div className="-mx-4  mt-6 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className=" overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg">
              <form>   
                  {/* <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label> */}
                  <div class="relative w-2/5 float-right my-2">
                      <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                          </svg>
                      </div>
                      <input onChange={(e)=>{setSearch(e.target.value)}} value={search} type="search" id="default-search" className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search Mockups, Logos..." required ></input>
                      {/* <button type="submit" class="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Search</button> */}
                  </div>
              </form>
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" >
                  <thead className="bg-gray-50  dark:bg-gray-800">
                    <tr>
                      {/* <th
                        scope="col"
                        className="py-3.5 px-4 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        <div className="flex items-center gap-x-3">
                          <span>Id</span>
                        </div>
                      </th> */}
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        <span className="">Merged</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                         Invoice
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                       Company
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        NSC
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        MC
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        DOT
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        Dispatcher
                      </th>

         
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        <span className="">Action</span>
                      </th>
                      
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-md font-sm text-gray-700 rtl:text-right dark:text-gray-400"
                      >
                        <span className="">Invoice</span>
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-900">
                    {tableData ? (
                      <>
                        { currentData.length>0? currentData.map((data, index) => (
                          <>
                            <tr>
                              {/* <td className="whitespace-nowrap px-4 py-4 text-sm font-medium text-gray-700">
                                <div className="inline-flex items-center gap-x-3">
                                  <div className="flex items-center gap-x-2">
                                    <div>
                                      <h2 className="font-medium text-gray-800 dark:text-white ">
                                        {data.id}
                                      </h2>
                                    </div>
                                  </div>
                                </div>
                              </td> */}
                              <td className="whitespace-nowrap px-4 py-4 text-sm text-center">
                                {data.merged_invoice!=null?<div className=" items-center gap-x-6">
                                  <a href={`${host}/public${data.merged_invoice}`} target="__blank"  className="text-teal-500 transition-colors duration-200 hover:text-red-500 focus:outline-none dark:text-gray-300 dark:hover:text-red-500">
                                  {/* <img src="/pdf.png" width="5px" /> */}
                                  <svg width="30px" height="30px" className="m-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V11C19 11.5523 19.4477 12 20 12C20.5523 12 21 11.5523 21 11V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM10.3078 23.5628C10.4657 23.7575 10.6952 23.9172 10.9846 23.9762C11.2556 24.0316 11.4923 23.981 11.6563 23.9212C11.9581 23.8111 12.1956 23.6035 12.3505 23.4506C12.5941 23.2105 12.8491 22.8848 13.1029 22.5169C14.2122 22.1342 15.7711 21.782 17.287 21.5602C18.1297 21.4368 18.9165 21.3603 19.5789 21.3343C19.8413 21.6432 20.08 21.9094 20.2788 22.1105C20.4032 22.2363 20.5415 22.3671 20.6768 22.4671C20.7378 22.5122 20.8519 22.592 20.999 22.6493C21.0755 22.6791 21.5781 22.871 22.0424 22.4969C22.3156 22.2768 22.5685 22.0304 22.7444 21.7525C22.9212 21.4733 23.0879 21.0471 22.9491 20.5625C22.8131 20.0881 22.4588 19.8221 22.198 19.6848C21.9319 19.5448 21.6329 19.4668 21.3586 19.4187C21.11 19.3751 20.8288 19.3478 20.5233 19.3344C19.9042 18.5615 19.1805 17.6002 18.493 16.6198C17.89 15.76 17.3278 14.904 16.891 14.1587C16.9359 13.9664 16.9734 13.7816 17.0025 13.606C17.0523 13.3052 17.0824 13.004 17.0758 12.7211C17.0695 12.4497 17.0284 12.1229 16.88 11.8177C16.7154 11.4795 16.416 11.1716 15.9682 11.051C15.5664 10.9428 15.1833 11.0239 14.8894 11.1326C14.4359 11.3004 14.1873 11.6726 14.1014 12.0361C14.0288 12.3437 14.0681 12.6407 14.1136 12.8529C14.2076 13.2915 14.4269 13.7956 14.6795 14.2893C14.702 14.3332 14.7251 14.3777 14.7487 14.4225C14.5103 15.2072 14.1578 16.1328 13.7392 17.0899C13.1256 18.4929 12.4055 19.8836 11.7853 20.878C11.3619 21.0554 10.9712 21.2584 10.6746 21.4916C10.4726 21.6505 10.2019 21.909 10.0724 22.2868C9.9132 22.7514 10.0261 23.2154 10.3078 23.5628ZM11.8757 23.0947C11.8755 23.0946 11.8775 23.0923 11.8824 23.0877C11.8783 23.0924 11.8759 23.0947 11.8757 23.0947ZM16.9974 19.5812C16.1835 19.7003 15.3445 19.8566 14.5498 20.0392C14.9041 19.3523 15.2529 18.6201 15.5716 17.8914C15.7526 17.4775 15.9269 17.0581 16.0885 16.6431C16.336 17.0175 16.5942 17.3956 16.8555 17.7681C17.2581 18.3421 17.6734 18.911 18.0759 19.4437C17.7186 19.4822 17.3567 19.5287 16.9974 19.5812ZM16.0609 12.3842C16.0608 12.3829 16.0607 12.3823 16.0606 12.3823C16.0606 12.3822 16.0607 12.3838 16.061 12.3872C16.061 12.386 16.0609 12.385 16.0609 12.3842Z" fill="#e11d48"/>
                                  </svg>
                                  </a>
                                </div>:''}
                              </td>
                              <td className=" px-4  py-4 text-base text-gray-900 dark:text-gray-300 font-extrabold">
                              <p class="font-extrabold ">#{data.invoice_no}</p>
                              </td>
                              <td className=" px-4  py-4 text-sm text-purple-500 dark:text-purple-300">
                                {data.companyName}
                              </td>
                              <td className=" px-4  py-4 text-sm text-gray-700 dark:text-teal-300">
                                {data.nscNo}
                              </td>
                              <td className=" px-4  py-4 text-sm text-gray-700 dark:text-cyan-300">
                                {data.mcNo}
                              </td>
                               <td className=" px-4  py-4 text-sm text-gray-700 dark:text-lime-300">
                                {data.dotNo}
                              </td>
                              <td className=" px-4  py-4 text-sm text-gray-700 dark:text-gray-300">
                                {data.dispatcher}
                              </td>
                             
                          
                              <td className="whitespace-nowrap px-4 py-4 text-sm">
                                <div className="flex items-center gap-x-6">

                                  {/* <Link to={`${deleteRoute}/${data.id}`}>
                                    <button className="text-gray-500 transition-colors duration-200 hover:text-red-500 focus:outline-none dark:text-gray-300 dark:hover:text-red-500">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="h-5 w-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                        />
                                      </svg>
                                    </button>
                                  </Link> */}
                                  <Link to={`${editRoute}/${data.id}`}>
                                    <button className="text-teal-500 transition-colors duration-200 hover:text-yellow-500 focus:outline-none dark:text-gray-300 dark:hover:text-yellow-500">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="h-5 w-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                        />
                                      </svg>
                                    </button>
                                  </Link>
                                </div>
                              </td>

                              <td className="whitespace-nowrap px-4 py-4 text-sm">
                                <div className=" items-center gap-x-6">
                                  <Link to={`${generateInvoice}/${data.id}`}>
                                  <button class="bg-blue-50 w-32 hover:bg-gray-400 text-gray-800 font-bold p-2 px-4 rounded inline-flex items-center justify-around">
                                    <span className="pr-3">{data.invoiced=='pending'?'Invoice':'Reinvoice'}</span>
                                    <svg className="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="IconChangeColor" height="18" width="18">
                                      <path d="M511.6 36.86l-64 415.1c-1.5 9.734-7.375 18.22-15.97 23.05c-4.844 2.719-10.27 4.097-15.68 4.097c-4.188 0-8.319-.8154-12.29-2.472l-122.6-51.1l-50.86 76.29C226.3 508.5 219.8 512 212.8 512C201.3 512 192 502.7 192 491.2v-96.18c0-7.115 2.372-14.03 6.742-19.64L416 96l-293.7 264.3L19.69 317.5C8.438 312.8 .8125 302.2 .0625 289.1s5.469-23.72 16.06-29.77l448-255.1c10.69-6.109 23.88-5.547 34 1.406S513.5 24.72 511.6 36.86z" id="mainIconPathAttribute" fill="#8b5cf6" stroke-width="2" stroke="#8b5cf6" filter="url(#shadow)"></path>
                                    </svg>
                                  </button>
                                    
                                  </Link>
                                </div>
                              </td>
                              
                            </tr>
                          </>
                        )):<tr><td colSpan={9} className="text-center">No Data Found</td></tr>}
                      </>
                    ) : (
                      <>Loading Data</>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 gap-4 flex items-center justify-end">
          <button
           onClick={handlePreviousPage} disabled={currentPage === 1}
            className="flex items-center gap-x-2 rounded-md border bg-white px-5 py-2 text-sm capitalize text-gray-700 transition-colors duration-200 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="h-5 w-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>
            <span>previous</span>
          </button>
         
          <button
           onClick={handleNextPage} disabled={currentPage === totalPages}
            className="flex items-center gap-x-2 rounded-md border bg-white px-5 py-2 text-sm capitalize text-gray-700 transition-colors duration-200 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            <span>Next</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="h-5 w-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </button>
        </div>
      </section>
    </>
  );
}
